import { render, staticRenderFns } from "./TeamsTable.vue?vue&type=template&id=33edc581"
import script from "./TeamsTable.vue?vue&type=script&lang=js"
export * from "./TeamsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports